import { c as _c } from "react/compiler-runtime";
import { mergeTailwindClasses } from '@xefi/x-react/utils';
import Image from 'next/image';
import { useState } from 'react';
import regularStar from '@/assets/img/answers/regular-star.png';
import solidStar from '@/assets/img/answers/solid-star.png';
type RatingStarFieldProps = {
  value?: string;
  choices?: string[];
  onChange?: (value?: string) => void;
  canSelectNoOption?: boolean;
  isDisabled?: boolean;
};
export const RatingStarField = t0 => {
  const $ = _c(17);
  const {
    choices,
    value,
    onChange,
    canSelectNoOption,
    isDisabled
  } = t0;
  const [hoverRating, setHoverRating] = useState(0);
  const isRequired = !canSelectNoOption;
  const choiceIndex = parseInt((hoverRating || (value ?? "1")).toString(), 10) - 1;
  const t1 = isDisabled && "pointer-events-none";
  let t2;
  if ($[0] !== t1) {
    t2 = mergeTailwindClasses("flex h-[30px] items-center gap-4", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = Array.from({
      length: 5
    });
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== canSelectNoOption || $[4] !== hoverRating || $[5] !== isDisabled || $[6] !== isRequired || $[7] !== onChange || $[8] !== value) {
    t4 = <div className="border-border flex gap-2 rounded-lg border p-2">{t3.map((_, index) => <div key={index} onMouseEnter={() => setHoverRating(index + 1)} onMouseLeave={() => setHoverRating(0)} onClick={() => (index + 1).toString() === value && canSelectNoOption ? onChange?.(undefined) : onChange?.((index + 1).toString())} className="cursor-pointer"><input type="radio" disabled={isDisabled} value={isRequired ? undefined : index} checked={value === index.toString()} style={{
          display: "none"
        }} /><Image src={index < (hoverRating || parseInt(value ?? "", 10)) ? solidStar : regularStar} width={20} alt="star" /></div>)}</div>;
    $[3] = canSelectNoOption;
    $[4] = hoverRating;
    $[5] = isDisabled;
    $[6] = isRequired;
    $[7] = onChange;
    $[8] = value;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== choiceIndex || $[11] !== choices) {
    t5 = choices && choices.length >= 5 && choices[choiceIndex] && <p className="border-border rounded-lg border p-2">{choices[choiceIndex]}</p>;
    $[10] = choiceIndex;
    $[11] = choices;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t2 || $[14] !== t4 || $[15] !== t5) {
    t6 = <div className={t2}>{t4}{t5}</div>;
    $[13] = t2;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};